'use client';
import React, { memo } from 'react';
import { IoChevronForward } from 'react-icons/io5';

import { NextImage, SmartLink } from '@/app/_components';
import { ROUTERS } from '@/constant';
import { useLang } from '@/hooks';

export const FormContact = memo(() => {
	const { t } = useLang();
	return (
		<>
			<div className="lg:flex px-[2rem] md:px-0 container lg:space-x-3">
				<div className="flex flex-col py-10">
					<div
						className={
							'flex md:min-w-[170px] max-w-[180px] max-sm:w-[140px] bg-center bg-cover object-center max-sm:h-auto -ml-1'
						}
					>
						<NextImage
							src={require('@/app/assets/image/logo/logoc4c.png')}
							alt={'LogoCode4Change'}
						/>
					</div>
					<div
						className={
							'block space-y-10 lg:flex lg:space-x-8 lg:space-y-0 mt-4'
						}
					>
						<div className="flex flex-col flex-1 space-y-4">
							<p className={'text-gray-7 font-semibold'}>
								{t('footer.title')}
							</p>
							<p className="text-base font-light text-gray-7/80">
								{t('footer.content')}
							</p>
							<button className="row font-semibold text-blue-2 max-w-max bg-transparent">
								{t('footer.btn')}
								<IoChevronForward className={'ml-2'} />
							</button>
						</div>
						<div className="md:flex flex-1 lg:space-x-3 space-y-6 md:space-y-0">
							<div className={'flex-1 space-y-4'}>
								<p className="text-gray-7 font-semibold whitespace-nowrap">
									{t('footer.link')}
								</p>
								<div className="flex flex-col space-y-2 text-base font-normal font-light text-gray-7/80">
									<SmartLink href={ROUTERS.ABOUT_US}>
										{t('footer.link.1')}
									</SmartLink>
									<SmartLink href={ROUTERS.PROJECT}>
										{t('footer.link.2')}
									</SmartLink>
									<SmartLink href={ROUTERS.BLOG}>
										{t('footer.link.3')}
									</SmartLink>
									<SmartLink href={ROUTERS.BLOG}>
										{t('footer.link.4')}
									</SmartLink>
								</div>
							</div>
							<div className={'flex-[2.5] space-y-4'}>
								<p className="text-gray-7 font-semibold">
									{t('footer.location')}
								</p>
								<div className="flex flex-col space-y-2 text-base font-normal font-light text-gray-7/80">
									<p>
										{t('location.address_flag')}:{' '}
										{t('location.address')}
									</p>
									<p>
										{t('location.mail_flag')}:
										support@code4change.dev
									</p>
									<p>
										{t('location.phone_flag')}: + 84 706 145
										483
									</p>
								</div>
								<div className={'space-x-4'}>
									<i
										className={
											'c4c-linkdln text-gray-7/80 text-xl cursor-pointer'
										}
									/>
									<i
										className={
											'c4c-facebook text-gray-7/80 text-xl cursor-pointer'
										}
									/>
									<i
										className={
											'c4c-instagram text-gray-7/80 text-xl cursor-pointer'
										}
									/>
									<i
										className={
											'c4c-youtube text-gray-7/80 text-xl cursor-pointer'
										}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className={'flex bg-gradient-default min-h-[60px] py-2'}>
				<div
					className={
						'px-[2rem] md:px-0 container lg:row lg:justify-between flex flex-col items-center justify-center'
					}
				>
					<span></span>
					<span className="font-normal text-white max-md:text-sm">
						© 2023 Code4Change. All rights reserved.
					</span>
				</div>
			</div>
		</>
	);
});
